import { useRef } from 'react'
import {
  Marker,
  useMap
} from 'react-leaflet'
import { useDispatch } from 'react-redux'
import { latLng } from 'leaflet'
import { createEventMarkerColor } from 'utils/helpers'
import { setEventData } from 'store'
import { v4 as uuid } from 'uuid'
import { useSearchParams } from 'react-router-dom'

export const CopyEventMarkerItem = ({
  eventItem,
  mapRef
}) => {
  const eventMarkerRef = useRef()
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()

  const map = useMap()
  const eventid = eventItem?.id

  const eventIconMarker = createEventMarkerColor(eventItem?.start_date)

  return (
    <Marker
      zIndexOffset={100000000}
      key={uuid()}
      eventHandlers={{
        click: (e) => {
          eventMarkerRef.current.closePopup()
          dispatch(setEventData())

          const trueLng = e.latlng.lng > 180 ? e.latlng.lng - 360 : e.latlng.lng + 360

          mapRef.current.setView([
            e.latlng.lat,
            trueLng
          ], localStorage.getItem('zoom'), { animate: true })

          setTimeout(() => {
            setSearchParams({ eventid })
          }, 300)
        }
      }}
      position={latLng(eventItem.lat, eventItem.lng)}
      icon={eventIconMarker}
      title={eventItem.id}
      ref={eventMarkerRef}
    />
  )
}
